import React from "react";
import "./AnimationIcons.scss";

/**
 * Iconos con animaciones integradas.
 *
 * @param {"rotate"}         animation  - Tipo de animación
 * @param {"right"|"left"}   direction  - Sentido de rotación (right = horario, left = antihorario)
 * @param {number}           velocity   - Velocidad en segundos (ej: 0.5 = rápido, 2 = lento). Default: 1
 * @param {string}           icon       - Nombre del icono (data-icon)
 * @param {string}           size       - Tamaño del icono (ej: "24px", "var(--icon-size)")
 * @param {string}           color      - Color del icono
 * @param {string}           className  - Clases adicionales
 */
const AnimationIcons = ({
    animation = "rotate",
    direction = "right",
    velocity = 1,
    icon = "progress_activity",
    size,
    color,
    severity,
    className = "",
}) => {
    return (
        <span
            data-icon={icon}
            className={`icon animation-icon animation-icon--${animation} animation-icon--${direction}${severity ? ` animation-icon--${severity}` : ''} ${className}`}
            style={{ fontSize: size, color, animationDuration: `${velocity}s` }}
        />
    );
};

export default AnimationIcons;
